import {Detail} from './Detail';

export class RisorsaMtConnect extends Detail  {
  risorsaId: number;
  xmlUrl: string;
  workingState: number;
}
